(function (window, $) {
  class Tooltip extends DropDownProxy {
    constructor(options) {
      const {
        $input,
        content = options.content || $input.attr("tooltip-content") || "",
        ...opt
      } = options;
      super({
        $input,
        canShow,
        ...opt,
      });

      DropDownProxy.tooltipInstances.push(this);

      function canShow() {
        return !$input.data("isShowConfirm") && !!content;
      }

      const $content = $(`<div class="tooltip-content">${content}</div>`);
      this.$html.append($content);
    }
  }

  window.Tooltip = Tooltip;

  $.fn.tooltip2 = function (options = {}) {
    if ($(this).data("tooltip")) return $(this);

    $(this).data(
      "tooltip",
      new Tooltip({
        selfOnly: true,
        placement: "bottom",
        trigger: "hover",
        $input: this,
        hoverHideThreshold: 0,
        ...options,
      }),
    );

    return $(this);
  };
})(window, jQuery);
